import { render, staticRenderFns } from "./SideMenuExpandEditableLink.vue?vue&type=template&id=3ffdbd86&scoped=true"
import script from "./SideMenuExpandEditableLink.vue?vue&type=script&lang=ts"
export * from "./SideMenuExpandEditableLink.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuExpandEditableLink.vue?vue&type=style&index=0&id=3ffdbd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffdbd86",
  null
  
)

export default component.exports